(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Zo-prodact-grid-V3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileViewport = window.matchMedia('(max-width: 900px)');

    const syncFilterPanels = () => {
      document.querySelectorAll('.zo-collection-grid-v3__filters').forEach((panel) => {
        const mode = mobileViewport.matches ? 'mobile' : 'desktop';
        if (panel.dataset.zoGridViewportMode === mode) return;
        panel.open = mode === 'desktop';
        panel.dataset.zoGridViewportMode = mode;
      });
    };

    const enforceRequiredFilters = () => {
      document.querySelectorAll('.zo-collection-grid-v3[data-required-filter-url]').forEach((grid) => {
        if (grid.dataset.requiredFilterActive === 'true') return;
        const url = grid.dataset.requiredFilterUrl;
        if (url) window.location.replace(url);
      });
    };

    const initialize = () => {
      syncFilterPanels();
      enforceRequiredFilters();
    };

    initialize();

    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', syncFilterPanels);
    } else {
      mobileViewport.addListener(syncFilterPanels);
    }

    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileViewport = window.matchMedia('(max-width: 900px)');

    const buildStrictTitleQuery = (value) => {
      const raw = value.trim();
      if (!raw || /(?:^|\s)(?:AND|OR|NOT)(?:\s|$)/i.test(raw) || raw.includes('title:')) return raw;

      const words = raw.match(/[\p{L}\p{N}][\p{L}\p{N}_-]*/gu) || [];
      const hasPartNumber = words.some((word) => /^\d{5,}$/.test(word) || (/\d/.test(word) && word.length >= 9));

      if (words.length < 2 || hasPartNumber) return raw;
      return words.map((word) => `title:${word}`).join(' AND ');
    };

    const prepareStrictSearchForms = () => {
      document.querySelectorAll('.zo-search-grid-v3__query').forEach((form) => {
        if (form.dataset.zoStrictSearchReady === 'true') return;
        form.dataset.zoStrictSearchReady = 'true';

        form.addEventListener('submit', () => {
          const input = form.querySelector('input[name="q"]');
          if (input) input.value = buildStrictTitleQuery(input.value);
        });
      });
    };

    const enforceStrictSearchUrl = () => {
      const url = new URL(window.location.href);
      const currentQuery = url.searchParams.get('q') || '';
      const strictQuery = buildStrictTitleQuery(currentQuery);

      if (strictQuery && strictQuery !== currentQuery) {
        url.searchParams.set('q', strictQuery);
        window.location.replace(url.toString());
      }
    };

    const syncFilterPanels = () => {
      document.querySelectorAll('.zo-collection-grid-v3__filters').forEach((panel) => {
        const mode = mobileViewport.matches ? 'mobile' : 'desktop';
        if (panel.dataset.zoGridViewportMode === mode) return;
        panel.open = mode === 'desktop';
        panel.dataset.zoGridViewportMode = mode;
      });
    };

    const initialize = () => {
      syncFilterPanels();
      prepareStrictSearchForms();
      enforceStrictSearchUrl();
    };

    initialize();

    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', syncFilterPanels);
    } else {
      mobileViewport.addListener(syncFilterPanels);
    }

    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zo-cart-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseSection = (html) => {
      const container = document.createElement('div');
      container.innerHTML = html;
      return container.querySelector('[data-zo-cart]');
    };

    const initializeCart = (section) => {
      if (!section || section.dataset.cartInitialized === 'true') return;
      section.dataset.cartInitialized = 'true';

      const form = section.querySelector('form');
      const updateButton = section.querySelector('[data-cart-update]');
      const sectionId = section.dataset.sectionId;
      const changeUrl = section.dataset.cartChangeUrl;
      const updateUrl = section.dataset.cartUpdateUrl;
      const pendingTimers = new Map();
      let activeController;

      const replaceSection = (html) => {
        const nextSection = parseSection(html);
        if (!nextSection) return false;
        section.replaceWith(nextSection);
        initializeCart(nextSection);
        return true;
      };

      const renderCart = async (response) => {
        const sectionHtml = response.sections?.[sectionId];
        if (sectionHtml && replaceSection(sectionHtml)) return;

        const separator = window.location.search ? '&' : '?';
        const renderResponse = await fetch(`${window.location.pathname}${window.location.search}${separator}section_id=${encodeURIComponent(sectionId)}`, {
          headers: { Accept: 'text/html' }
        });
        if (!renderResponse.ok) throw new Error('Unable to refresh cart');
        replaceSection(await renderResponse.text());
      };

      const requestCart = async (url, payload) => {
        if (!url || !sectionId) return;
        activeController?.abort();
        activeController = new AbortController();
        section.classList.add('is-updating');
        section.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(`${url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              ...payload,
              sections: [sectionId],
              sections_url: window.location.pathname
            }),
            signal: activeController.signal
          });

          const cartResponse = await response.json();
          if (!response.ok) throw new Error(cartResponse.description || 'Unable to update cart');
          await renderCart(cartResponse);
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartResponse } }));
        } catch (error) {
          if (error.name !== 'AbortError') {
            section.classList.remove('is-updating');
            section.removeAttribute('aria-busy');
            window.location.reload();
          }
        }
      };

      const scheduleLineUpdate = (input, delay = 160) => {
        const line = input.closest('[data-cart-line]');
        const lineKey = line?.dataset.lineKey;
        if (!lineKey) return;
        window.clearTimeout(pendingTimers.get(lineKey));
        pendingTimers.set(lineKey, window.setTimeout(() => {
          pendingTimers.delete(lineKey);
          requestCart(changeUrl, {
            id: lineKey,
            quantity: Math.max(Number(input.min) || 0, Number(input.value) || 0)
          });
        }, delay));
      };

      section.querySelectorAll('[data-quantity-input]').forEach((input) => {
        const row = input.closest('.zo-cart__quantity');
        const line = input.closest('[data-cart-line]');
        const minus = row?.querySelector('[data-quantity-minus]');
        const plus = row?.querySelector('[data-quantity-plus]');
        const wholesaleAlert = line?.querySelector('[data-cart-wholesale-alert]');
        const purchaseLimit = Number(input.dataset.purchaseLimit) || 3;
        const storedQuantity = Number(input.dataset.currentQuantity) || 0;

        const showWholesaleAlert = () => {
          if (wholesaleAlert) wholesaleAlert.hidden = false;
        };

        const setAlertState = (value) => {
          if (!wholesaleAlert) return;
          if (value > purchaseLimit) showWholesaleAlert();
          else if (value < purchaseLimit) wholesaleAlert.hidden = true;
        };

        const changeQuantity = (direction) => {
          const current = Number(input.value) || 0;
          const min = Number(input.min) || 0;
          const requested = Math.max(min, current + direction);
          if (requested > purchaseLimit) {
            showWholesaleAlert();
            return;
          } else {
            input.value = requested;
            setAlertState(requested);
          }
          scheduleLineUpdate(input);
        };

        minus?.addEventListener('click', () => changeQuantity(-1));
        plus?.addEventListener('click', () => changeQuantity(1));
        input.addEventListener('change', () => {
          const min = Number(input.min) || 0;
          const requested = Math.max(min, Number(input.value) || min);
          if (requested > purchaseLimit) {
            input.value = Math.max(min, storedQuantity);
            showWholesaleAlert();
            return;
          } else {
            setAlertState(requested);
          }
          scheduleLineUpdate(input, 0);
        });
      });

      section.querySelectorAll('[data-cart-remove]').forEach((removeLink) => {
        removeLink.addEventListener('click', (event) => {
          event.preventDefault();
          const lineKey = removeLink.closest('[data-cart-line]')?.dataset.lineKey;
          if (lineKey) requestCart(changeUrl, { id: lineKey, quantity: 0 });
        });
      });

      form?.addEventListener('submit', (event) => {
        if (event.submitter !== updateButton) return;
        event.preventDefault();
        const updates = {};
        section.querySelectorAll('[data-cart-line]').forEach((line) => {
          const input = line.querySelector('[data-quantity-input]');
          if (line.dataset.lineKey && input) updates[line.dataset.lineKey] = Math.max(Number(input.min) || 0, Number(input.value) || 0);
        });
        requestCart(updateUrl, { updates });
      });
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-zo-cart]').forEach(initializeCart);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zo-dodge-product-grid-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileViewport = window.matchMedia('(max-width: 900px)');

    const syncFilterPanels = () => {
      document.querySelectorAll('.zo-dodge-grid-v2__filters').forEach((panel) => {
        const mode = mobileViewport.matches ? 'mobile' : 'desktop';
        if (panel.dataset.zoV2ViewportMode === mode) return;
        panel.open = mode === 'desktop';
        panel.dataset.zoV2ViewportMode = mode;
      });
    };

    const enforceRequiredFilters = () => {
      document.querySelectorAll('.zo-dodge-grid-v2[data-required-filter-url]').forEach((grid) => {
        if (grid.dataset.requiredFilterActive === 'true') return;
        const url = grid.dataset.requiredFilterUrl;
        if (url) window.location.replace(url);
      });
    };

    const initialize = () => {
      syncFilterPanels();
      enforceRequiredFilters();
    };

    initialize();

    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', syncFilterPanels);
    } else {
      mobileViewport.addListener(syncFilterPanels);
    }

    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zo-product-grid-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileViewport = window.matchMedia('(max-width: 900px)');

    const syncFilterPanels = () => {
      document.querySelectorAll('.zo-product-grid__filters').forEach((panel) => {
        const nextMode = mobileViewport.matches ? 'mobile' : 'desktop';

        if (panel.dataset.zoViewportMode === nextMode) return;

        panel.open = nextMode === 'desktop';
        panel.dataset.zoViewportMode = nextMode;
      });
    };

    const enforceRequiredFilters = () => {
      document.querySelectorAll('.zo-product-grid[data-required-filter-url]').forEach((grid) => {
        if (grid.dataset.requiredFilterActive === 'true') return;

        const requiredFilterUrl = grid.dataset.requiredFilterUrl;
        if (requiredFilterUrl) window.location.replace(requiredFilterUrl);
      });
    };

    syncFilterPanels();
    enforceRequiredFilters();

    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', syncFilterPanels);
    } else {
      mobileViewport.addListener(syncFilterPanels);
    }

    document.addEventListener('shopify:section:load', () => {
      syncFilterPanels();
      enforceRequiredFilters();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zo-product-information-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSection = (section) => {
      if (!section || section.dataset.zoInitialized === 'true') return;
      section.dataset.zoInitialized = 'true';

      const slides = Array.from(section.querySelectorAll('[data-media-id].zo-product-v2__slide'));
      const thumbnails = Array.from(section.querySelectorAll('[data-thumbnail]'));

      const showMedia = (mediaId) => {
        if (!mediaId) return;
        slides.forEach((slide) => {
          const active = slide.dataset.mediaId === String(mediaId);
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbnails.forEach((thumbnail) => {
          const active = thumbnail.dataset.mediaId === String(mediaId);
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-pressed', String(active));
          if (active) thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      };

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => showMedia(thumbnail.dataset.mediaId));
      });

      const stepMedia = (direction) => {
        if (!slides.length) return;
        const currentIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));
        const nextIndex = (currentIndex + direction + slides.length) % slides.length;
        showMedia(slides[nextIndex].dataset.mediaId);
      };

      section.querySelector('[data-gallery-previous]')?.addEventListener('click', () => stepMedia(-1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => stepMedia(1));

      const quantityInput = section.querySelector('[data-quantity-input]');
      const changeQuantity = (direction) => {
        if (!quantityInput) return;
        const step = Number(quantityInput.step) || 1;
        const min = Number(quantityInput.min) || 1;
        const max = quantityInput.max ? Number(quantityInput.max) : Infinity;
        const current = Number(quantityInput.value) || min;
        quantityInput.value = Math.min(max, Math.max(min, current + direction * step));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => changeQuantity(-1));
      section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => changeQuantity(1));

      const variantSelect = section.querySelector('[data-variant-select]');
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const sku = section.querySelector('[data-product-sku]');
      const addButton = section.querySelector('[data-add-button]');
      const addButtonLabel = section.querySelector('[data-add-button-label]');

      variantSelect?.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';

        if (price) price.textContent = option.dataset.price || '';
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.classList.toggle('is-hidden', !option.dataset.compare);
        }
        if (sku) sku.textContent = option.dataset.sku || '';
        if (addButton) addButton.disabled = !available;
        if (addButtonLabel) {
          addButtonLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        if (option.dataset.mediaId) showMedia(option.dataset.mediaId);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });

      const lightbox = section.querySelector('[data-lightbox]');
      const lightboxImage = section.querySelector('[data-lightbox-image] img');

      section.querySelectorAll('[data-open-lightbox]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!lightbox || !lightboxImage) return;
          lightboxImage.src = button.dataset.fullImage || '';
          lightboxImage.alt = button.dataset.imageAlt || '';
          lightbox.showModal();
        });
      });

      section.querySelector('[data-close-lightbox]')?.addEventListener('click', () => lightbox?.close());
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-zo-product-v2]').forEach(initializeSection);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zo-product-information-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSection = (section) => {
      if (!section || section.dataset.zoInitialized === 'true') return;
      section.dataset.zoInitialized = 'true';

      const slides = Array.from(section.querySelectorAll('[data-media-id].zo-product-v2__slide'));
      const thumbnails = Array.from(section.querySelectorAll('[data-thumbnail]'));

      const showMedia = (mediaId) => {
        if (!mediaId) return;
        slides.forEach((slide) => {
          const active = slide.dataset.mediaId === String(mediaId);
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbnails.forEach((thumbnail) => {
          const active = thumbnail.dataset.mediaId === String(mediaId);
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-pressed', String(active));
          if (active) thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      };

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => showMedia(thumbnail.dataset.mediaId));
      });

      const stepMedia = (direction) => {
        if (!slides.length) return;
        const currentIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));
        const nextIndex = (currentIndex + direction + slides.length) % slides.length;
        showMedia(slides[nextIndex].dataset.mediaId);
      };

      section.querySelector('[data-gallery-previous]')?.addEventListener('click', () => stepMedia(-1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => stepMedia(1));

      const quantityInput = section.querySelector('[data-quantity-input]');
      const changeQuantity = (direction) => {
        if (!quantityInput) return;
        const step = Number(quantityInput.step) || 1;
        const min = Number(quantityInput.min) || 1;
        const max = quantityInput.max ? Number(quantityInput.max) : Infinity;
        const current = Number(quantityInput.value) || min;
        quantityInput.value = Math.min(max, Math.max(min, current + direction * step));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => changeQuantity(-1));
      section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => changeQuantity(1));

      const variantSelect = section.querySelector('[data-variant-select]');
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const sku = section.querySelector('[data-product-sku]');
      const addButton = section.querySelector('[data-add-button]');
      const addButtonLabel = section.querySelector('[data-add-button-label]');

      variantSelect?.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';

        if (price) price.textContent = option.dataset.price || '';
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.classList.toggle('is-hidden', !option.dataset.compare);
        }
        if (sku) sku.textContent = option.dataset.sku || '';
        if (addButton) addButton.disabled = !available;
        if (addButtonLabel) {
          addButtonLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        if (option.dataset.mediaId) showMedia(option.dataset.mediaId);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });

      const lightbox = section.querySelector('[data-lightbox]');
      const lightboxImage = section.querySelector('[data-lightbox-image] img');

      section.querySelectorAll('[data-open-lightbox]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!lightbox || !lightboxImage) return;
          lightboxImage.src = button.dataset.fullImage || '';
          lightboxImage.alt = button.dataset.imageAlt || '';
          lightbox.showModal();
        });
      });

      section.querySelector('[data-close-lightbox]')?.addEventListener('click', () => lightbox?.close());
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-zo-product-v2]').forEach(initializeSection);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zo-product-information-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadTamaraWidget = () => {
      if (customElements.get('tamara-widget')) return Promise.resolve();
      if (window.zoTamaraWidgetPromise) return window.zoTamaraWidgetPromise;
      window.zoTamaraWidgetPromise = new Promise((resolve, reject) => {
        const url = 'https://cdn.tamara.co/widget-v2/tamara-widget.js';
        let script = document.querySelector(`script[src="${url}"]`);
        const existingScript = Boolean(script);
        if (!script) {
          script = document.createElement('script');
          script.src = url;
          script.async = true;
        }
        script.addEventListener('load', () => {
          if (customElements.get('tamara-widget')) resolve();
          else reject(new Error('Tamara widget unavailable'));
        }, { once: true });
        script.addEventListener('error', () => {
          script.remove();
          window.zoTamaraWidgetPromise = null;
          reject(new Error('Tamara widget could not load'));
        }, { once: true });
        if (!existingScript) document.head.appendChild(script);
      });
      return window.zoTamaraWidgetPromise;
    };

    const initializeTamara = (section) => {
      const container = section.querySelector('[data-zo-tamara]');
      if (!container) return () => {};
      let widget = null;
      const configure = () => {
        window.tamaraWidgetConfig = {
          ...(window.tamaraWidgetConfig || {}),
          lang: container.dataset.lang,
          country: 'AE',
          publicKey: container.dataset.publicKey,
          css: ':host { --font-primary: inherit !important; --font-secondary: inherit !important; }',
          style: { fontSize: '14px', badgeRatio: 1.2 }
        };
      };
      const update = (priceCents, available) => {
        container.dataset.priceCents = String(priceCents);
        container.dataset.available = String(available);
        const amount = Number(priceCents);
        const visible = available && Number.isFinite(amount) && amount > 0;
        container.hidden = !widget || !visible;
        if (!widget) return;
        const nextAmount = (amount / 100).toFixed(2);
        if (widget.getAttribute('amount') !== nextAmount && Number.isFinite(amount)) {
          widget.setAttribute('amount', nextAmount);
          configure();
          window.TamaraWidgetV2?.refresh();
        }
      };
      configure();
      loadTamaraWidget().then(() => {
        if (!container.isConnected) return;
        configure();
        const amount = Number(container.dataset.priceCents);
        if (!Number.isFinite(amount)) return;
        widget = document.createElement('tamara-widget');
        widget.id = `zo-tamara-${section.id}`;
        widget.setAttribute('type', 'tamara-summary');
        widget.setAttribute('inline-type', '2');
        widget.setAttribute('amount', (amount / 100).toFixed(2));
        widget.setAttribute('config', JSON.stringify({ badgePosition: 'right', showExtraContent: '' }));
        container.hidden = container.dataset.available !== 'true' || amount <= 0;
        container.replaceChildren(widget);
      }).catch(() => {
        container.hidden = true;
      });
      return update;
    };

    const initializeSection = (section) => {
      if (!section || section.dataset.zoInitialized === 'true') return;
      section.dataset.zoInitialized = 'true';
      const updateTamara = initializeTamara(section);

      const slides = Array.from(section.querySelectorAll('[data-media-id].zo-product-v2__slide'));
      const thumbnails = Array.from(section.querySelectorAll('[data-thumbnail]'));
      const fallbackSlide = section.querySelector('[data-variant-media-fallback]');
      const fallbackImage = fallbackSlide?.querySelector('img');
      const fallbackButton = fallbackSlide?.querySelector('[data-open-lightbox]');
      const lightbox = section.querySelector('[data-lightbox]');
      const lightboxImage = section.querySelector('[data-lightbox-image] img');

      const normalizeImageUrl = (value) => String(value || '').split('?')[0].replace(/^https?:/, '');

      const updateLightboxSource = (button) => {
        if (!lightboxImage || !button) return;
        lightboxImage.removeAttribute('srcset');
        lightboxImage.removeAttribute('sizes');
        lightboxImage.src = button.dataset.fullImage || '';
        lightboxImage.alt = button.dataset.imageAlt || '';
      };

      const showMedia = (mediaId, imageId, imageUrl) => {
        const normalizedImageUrl = normalizeImageUrl(imageUrl);
        const targetSlide =
          slides.find((slide) => mediaId && slide.dataset.mediaId === String(mediaId)) ||
          slides.find((slide) => imageId && slide.dataset.imageId === String(imageId)) ||
          slides.find((slide) => normalizedImageUrl && normalizeImageUrl(slide.dataset.imageUrl) === normalizedImageUrl);

        if (!targetSlide) return false;
        slides.forEach((slide) => {
          const active = slide === targetSlide;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        if (fallbackSlide) {
          fallbackSlide.hidden = true;
          fallbackSlide.classList.remove('is-active');
        }
        thumbnails.forEach((thumbnail) => {
          const active =
            thumbnail.dataset.mediaId === targetSlide.dataset.mediaId ||
            (targetSlide.dataset.imageId && thumbnail.dataset.imageId === targetSlide.dataset.imageId) ||
            (targetSlide.dataset.imageUrl && normalizeImageUrl(thumbnail.dataset.imageUrl) === normalizeImageUrl(targetSlide.dataset.imageUrl));
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-pressed', String(active));
          if (active) thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
        updateLightboxSource(targetSlide.querySelector('[data-open-lightbox]'));
        return true;
      };

      const showVariantMedia = (option) => {
        if (!option) return;
        const matched = showMedia(option.dataset.mediaId, option.dataset.imageId, option.dataset.imageUrl);
        if (matched || !option.dataset.imageUrl || !fallbackSlide || !fallbackImage) return;

        slides.forEach((slide) => {
          slide.hidden = true;
          slide.classList.remove('is-active');
        });
        thumbnails.forEach((thumbnail) => {
          thumbnail.classList.remove('is-active');
          thumbnail.setAttribute('aria-pressed', 'false');
        });

        fallbackImage.src = option.dataset.imageUrl;
        fallbackImage.alt = option.dataset.imageAlt || '';
        if (fallbackButton) {
          fallbackButton.dataset.fullImage = option.dataset.imageFull || option.dataset.imageUrl;
          fallbackButton.dataset.imageAlt = option.dataset.imageAlt || '';
        }
        fallbackSlide.hidden = false;
        fallbackSlide.classList.add('is-active');
        updateLightboxSource(fallbackButton);
      };

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => showMedia(thumbnail.dataset.mediaId));
      });

      const stepMedia = (direction) => {
        if (!slides.length) return;
        const currentIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));
        const nextIndex = (currentIndex + direction + slides.length) % slides.length;
        showMedia(slides[nextIndex].dataset.mediaId);
      };

      section.querySelector('[data-gallery-previous]')?.addEventListener('click', () => stepMedia(-1));
      section.querySelector('[data-gallery-next]')?.addEventListener('click', () => stepMedia(1));

      const quantityInput = section.querySelector('[data-quantity-input]');
      const wholesaleAlert = section.querySelector('[data-wholesale-alert]');
      const purchaseLimit = Number(quantityInput?.dataset.purchaseLimit) || 3;
      const showWholesaleAlert = () => {
        if (wholesaleAlert) wholesaleAlert.hidden = false;
      };
      const enforceQuantityLimit = () => {
        if (!quantityInput) return;
        const min = Number(quantityInput.min) || 1;
        const value = Number(quantityInput.value) || min;
        if (value > purchaseLimit) {
          quantityInput.value = purchaseLimit;
          showWholesaleAlert();
        } else if (value < purchaseLimit && wholesaleAlert) {
          wholesaleAlert.hidden = true;
        }
      };
      const changeQuantity = (direction) => {
        if (!quantityInput) return;
        const step = Number(quantityInput.step) || 1;
        const min = Number(quantityInput.min) || 1;
        const current = Number(quantityInput.value) || min;
        const requested = current + direction * step;
        if (requested > purchaseLimit) {
          quantityInput.value = purchaseLimit;
          showWholesaleAlert();
        } else {
          quantityInput.value = Math.max(min, requested);
        }
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => changeQuantity(-1));
      section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => changeQuantity(1));
      quantityInput?.addEventListener('input', enforceQuantityLimit);
      quantityInput?.addEventListener('change', enforceQuantityLimit);
      enforceQuantityLimit();

      const variantSelect = section.querySelector('[data-variant-select]');
      const variantButtons = Array.from(section.querySelectorAll('[data-variant-button]'));
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const sku = section.querySelector('[data-product-sku]');
      const partNumber = section.querySelector('[data-product-part-number]');
      const partNumberRow = section.querySelector('[data-part-number-row]');
      const addButton = section.querySelector('[data-add-button]');
      const addButtonLabel = section.querySelector('[data-add-button-label]');

      const partNumbersForOption = (option) => {
        const value = String(option.dataset.partNumber || option.dataset.sku || '').trim();
        return value ? [{ value }] : [];
      };
      const renderPartNumbers = (items) => {
        if (!partNumber || !partNumberRow) return;
        partNumber.innerHTML = '';
        items.forEach((item) => {
          const wrapper = document.createElement('span');
          wrapper.className = 'zo-product-v2__part-number-value';
          const value = document.createElement('strong');
          value.textContent = item.value;
          wrapper.append(value);
          partNumber.appendChild(wrapper);
        });
        partNumberRow.hidden = items.length === 0;
      };

      variantButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!variantSelect || button.disabled) return;
          variantSelect.value = button.dataset.variantId || '';
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      variantSelect?.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';

        if (price) price.textContent = option.dataset.price || '';
        updateTamara(Number(option.dataset.priceCents), available);
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.classList.toggle('is-hidden', !option.dataset.compare);
        }
        if (sku) sku.textContent = option.dataset.sku || '';
        renderPartNumbers(partNumbersForOption(option));
        variantButtons.forEach((button) => {
          const active = button.dataset.variantId === option.value;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        if (addButton) addButton.disabled = !available;
        if (addButtonLabel) {
          addButtonLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        showVariantMedia(option);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });

      variantSelect?.dispatchEvent(new Event('change', { bubbles: true }));

      section.querySelectorAll('[data-open-lightbox]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!lightbox || !lightboxImage) return;
          updateLightboxSource(button);
          lightbox.showModal();
        });
      });

      section.querySelector('[data-close-lightbox]')?.addEventListener('click', () => lightbox?.close());
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-zo-product-v2]').forEach(initializeSection);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zo-related-parts-premium"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zo-related-parts')) {
    class ZoRelatedParts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';

        const url = this.dataset.url;
        const target = this.querySelector('[data-related-inner]');
        if (!url || !target) return;

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error('Recommendations unavailable');
            return response.text();
          })
          .then((text) => {
            const documentFragment = new DOMParser().parseFromString(text, 'text/html');
            const source = documentFragment.querySelector(`zo-related-parts[data-section-id="${this.dataset.sectionId}"] [data-related-inner]`);
            if (!source) throw new Error('Recommendations markup unavailable');
            target.innerHTML = source.innerHTML;
            if (target.querySelector('[data-related-empty]')) this.hidden = true;
          })
          .catch(() => {
            this.hidden = true;
          });
      }
    }

    customElements.define('zo-related-parts', ZoRelatedParts);
  }

  } catch(e) { console.error(e); }
})();
})();
